import { PatientFilesState } from './types';
import { PatientFilesTypeAction } from './actions';
import { setAsyncData } from '../core';

const initialState: PatientFilesState = {
  data: {},
};

export function patientFilesReducer(state: PatientFilesState = initialState, action: PatientFilesTypeAction): PatientFilesState {
  switch (action.type) {
    case 'PATIENT_FILES_SET_FILES_FETCHING':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => {
            p.isFetching = action.data.fetching;
            p.error = action.data.error;
          }),
        },
      };

    // Return only files that exist:true (a file has been uploaded). Files that `exist:false` are cleaned up nightly.
    case 'PATIENT_FILES_SET_FILES':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => (p.data = action.data.files.filter((f) => f.exists))),
        },
      };

    case 'PATIENT_FILES_DELETE_FILE':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => {
            p.data = p.data!.slice();
            const index = p.data!.findIndex((f) => f._id === action.data.file._id);
            if (index > -1) {
              p.data!.splice(index, 1);
            }
          }),
        },
      };

    case 'PATIENT_FILES_APPROVE_FILE':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => {
            p.data = p.data!.slice();
            const index = p.data!.findIndex((f) => f._id === action.data.file.id);
            if (index > -1) {
              p.data![index] = {
                ...p.data![index],
                approved_on: action.data.file.approvedOn,
              };
            }
          }),
        },
      };

    case 'PATIENT_FILES_UPDATE_FILE':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => {
            p.data = p.data!.slice();
            const index = p.data!.findIndex((f) => f._id === action.data.file.id);
            if (index > -1) {
              p.data![index] = action.data.file;
            }
          }),
        },
      };

    case 'PATIENT_FILES_ADD_FILE':
      return {
        data: {
          ...state.data,
          [action.data.patientId]: setAsyncData(state.data[action.data.patientId] || { isFetching: false }, (p) => p.data!.unshift(action.data.file)),
        },
      };

    default:
      return state;
  }
}
